import { render, staticRenderFns } from "./PopupMascot.vue?vue&type=template&id=0fe37386&scoped=true&"
import script from "./PopupMascot.vue?vue&type=script&lang=js&"
export * from "./PopupMascot.vue?vue&type=script&lang=js&"
import style0 from "./PopupMascot.vue?vue&type=style&index=0&id=0fe37386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe37386",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fe37386')) {
      api.createRecord('0fe37386', component.options)
    } else {
      api.reload('0fe37386', component.options)
    }
    module.hot.accept("./PopupMascot.vue?vue&type=template&id=0fe37386&scoped=true&", function () {
      api.rerender('0fe37386', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popups/PopupMascot.vue"
export default component.exports